import { CampaignCategory, AvailableTicketsQuery, TicketModelCategory } from '~/generated/graphql'

type AvailableTicketAlertResult = {
  availableTicketAlert: string
  shouldShowNoTicketDialog: boolean
}

/**
 * 指定されたキャンペーンカテゴリと利用可能なチケットの一覧から、
 * アラートメッセージとチケット不足によるダイアログ表示要否を判定する。
 *
 * - 商品カテゴリ（Product）の場合、リモートチケットがなければ「自宅で体験（通販PR）」と表示。
 * - サービスカテゴリ（Service）の場合、ローカルチケットがなければ「現地で体験（店舗PR）」と表示。
 *
 * @param category - キャンペーンのカテゴリ
 * @param availableTickets - 利用可能なチケットの一覧
 * @returns アラートテキストと、チケットが不足しているかどうかの判定結果
 */
export const getAvailableTicketAlert = (
  category: CampaignCategory,
  availableTickets: (AvailableTicketsQuery['viewer']['company'] & { __typename: 'Company' })['availableTickets'],
): AvailableTicketAlertResult => {
  const hasLocalCategoryTicket = availableTickets.some((ticket) => ticket.category === TicketModelCategory.Locale)
  const hasRemoteCategoryTicket = availableTickets.some((ticket) => ticket.category === TicketModelCategory.Remote)

  const isProductCategoryWithoutTicket = category === CampaignCategory.Product && !hasRemoteCategoryTicket
  const isServiceCategoryWithoutTicket = category === CampaignCategory.Service && !hasLocalCategoryTicket

  const shouldShowNoTicketDialog = isProductCategoryWithoutTicket || isServiceCategoryWithoutTicket

  const alertText = []

  if (isProductCategoryWithoutTicket) {
    alertText.push('自宅で体験（通販PR）')
  }
  if (isServiceCategoryWithoutTicket) {
    alertText.push('現地で体験（店舗PR）')
  }

  return {
    availableTicketAlert: alertText.join('\n'),
    shouldShowNoTicketDialog,
  }
}
